module.exports = __webpack_public_path__ + "assets/img/tech-20.9c663f5f.svg";